<template>
  <div>
    <div id="input-card" v-show=false>
      <form @submit.prevent="lineSearch(newBus)">
        <label> Bus line Search</label>
        <input v-model="newBus" type="text" id="newBus" value="">
        <button type="submit" name="button" id="addBus">Add</button>
      </form>
      <ul>
        <p v-for="bus in busList" :key=bus.title>
          <input type="checkbox" v-model="bus.done">
          <span>{{bus.title}}</span>
          <button @click="removeBus(bus)">remove</button>
        </p>
      </ul>
    </div>
    <div class="amap-container" :id="mapId">
    </div>
  </div>
</template>
<script type="text/javascript" src="https://webapi.amap.com/maps?v=1.4.15&key=d00ecfa872d742bf6fd1a3b5acaeeb6c&plugin=AMap.LineSearch">
</script>


<script>
  import _global from './components/global.vue';
  import cq_gps_missing_line from './cq_added_line.json';
  export default {
    name: 'appAmap',
    props: ['mapId', 'isBusMap'],
    data() {
      return {
        newBus: '',
        radius_standard: 70,
        circle_nanjing: '',
        circle_wuhan: '',
        circle_shenzhen : '',
        circle_chongqing:'',
        circle_chengdu:'',
        radius_nanjing: 1,
        radius_wuhan: 1,
        radius_shenzhen:1,
        radius_chengdu:1,
        radius_chongqing:1,
        busList: [],    
        /* {title:'100路',done:true},
        {title:'20路',done:true},
        {title:'10路',done:true}	 */
        path: '',
        mapObj: '',
        busPolylineList: [],
        busMarkerList: [],
        cq_gps_missing_line_list:['121路','202路','401路','613路','486路','503路'],
        cq_gps_missing_line:cq_gps_missing_line
      }
    },
    mounted() {
      this.mapInit();
      //this.mapObj.setMapStyle('amap://styles/7660c77c0266eaa30bedae7affeb547d');
      if (this.isBusMap)
        this.busInit();
    },
    methods: {
      mapInit() {
        var mapObj = new AMap.Map(this.mapId, { //'amap-container'是对应页面盒子的id
          resizeEnable: true, //自适应大小
          zoom: 5.1, //初始视窗
          center: ['110.784136', '28.041806'],
          lang: 'zh_cn', //english map set 'en',
          //mapStyle:'amap://styles/10dacb09049f8af2e24836253c83695a',
          mapStyle: 'amap://styles/whitesmoke',
          showLabel: true,
          height: '500px',
        });
        this.mapObj = mapObj;
      },
      busInit() {
        //遍历buslist数组,使得每条线执行lineSearch()功能
        var busListNum = this.busList.length;
        for (var i = 0; i < busListNum; i++) {
          this.lineSearch(this.busList[i].title,chosen_city);
        }
      },
      addBus() {
        if (this.newBus != '') {
          this.busList.push({
            title: this.newBus,
            done: true
          });
          this.newBus = '';
        }
        //

      },
      removeBus(busLineName) {
        var busIndex = this.busList.indexOf(busLineName);
        var busPolylineListNum = this.busPolylineList.length;

        for (var i = 0; i < busPolylineListNum; i++) {
          var busNameFromPolyline = this.busPolylineList[i].getExtData().bus_name;
          if (busLineName.title == busNameFromPolyline) {
            var busPolylineIndex = i;
            break;
          }
        }

        this.mapObj.remove(this.busPolylineList[busPolylineIndex]);
        this.mapObj.remove(this.busMarkerList[busPolylineIndex]);
        this.busList.splice(busIndex, 1);
        this.busPolylineList.splice(busPolylineIndex, 1);
        this.busMarkerList.splice(busPolylineIndex, 1);
      },

      clearMap() {
        this.mapObj.clearMap();
      },


      lineSearch(busLineName,chosen_city) {
        //var busLineName = newBus.value;
        //if(!busLineName) return;
        let linesearch = new AMap.LineSearch({
          pageIndex: 1,
          city:  _global.gaodeCityDict[chosen_city],
          pageSize: 1,
          extensions: 'all'
        });
        var that = this;
        // Nanjing Gaode/Baidu has naming difference
        // Convert to bus name from baidu to gaode
        if (chosen_city == 'Nanjing' && busLineName == '3路'){
          busLineName = '3路内圈'
        }
        if (chosen_city == 'Nanjing' && busLineName == 'B1路'){
          busLineName = '南京站接驳线'
        }
        if (chosen_city == 'Chengdu' && busLineName == '137路'){
          busLineName = '137路（三环路外侧运行）'
        }
        linesearch.search(busLineName, function(status, result) {
          //map.clearMap()
          // Only recevie the type of bus (sometimes it returns metro) 
          /* if (status === 'complete' && result.info === 'OK' && result.lineInfo[0].type === '普通公交') { */
          if (chosen_city == 'Chongqing' && that.cq_gps_missing_line_list.includes(busLineName)){
            that.addBus();
            result = that.cq_gps_missing_line[busLineName]
            that.lineSearch_Callback(result, busLineName);
          }
          else if (status === 'complete' && result.info === 'OK') {
            that.addBus();
            that.lineSearch_Callback(result, busLineName);
          } else {
            that.$notify.error({
              title: 'Error',
              message: "The bus line is not normal: " + busLineName,
            });
          }
        });
      },
      lineSearch_Callback(data, busLineName) {
        var lineArr = data.lineInfo;
        var lineNum = data.lineInfo.length;
        var lineName = lineArr[0].name;

        if (lineNum == 0) {} else {
          for (var i = 0; i < lineNum; i++) {
            var pathArr = lineArr[i].path;
            var stops = lineArr[i].via_stops;
            var startPot = stops[0].location;
            // var endPot = stops[stops.length - 1].location;
            this.drawbusLine(startPot, pathArr, lineName, busLineName, lineArr);

          }
        }
      },
      drawbusLine(startPot, BusArr, lineName, busLineName, lineArr) {
        //绘制起点
        var busMarkerPosition = new AMap.LngLat(startPot['lng'],startPot['lat']);
        let busMarker = new AMap.Text({
          //map: this.mapObj,
          position: busMarkerPosition, //基点位置
          //content:content,
          text: busLineName,
          zIndex: 10
        });
        //绘制乘车的路线
        let busPolyline = new AMap.Polyline({
          //map: this.mapObj,
          path: BusArr,
          strokeColor: this.getRandomConfortColor(), //"#09f",//线颜色
          strokeOpacity: 0.8, //线透明度
          isOutline: true,
          outlineColor: 'white',
          strokeWeight: 6, //线宽
        });
        busPolyline.setExtData({
          bus_name: busLineName
        });
        this.busPolylineList.push(busPolyline);
        this.busMarkerList.push(busMarker);

        this.mapObj.add(busPolyline); //add polyline into the map
        this.mapObj.add(busMarker); //add marker into the map
        this.mapObj.setFitView();

        // bus line Info
        var lineCompany = lineArr[0].company;
        var lineStartStopName = lineArr[0].start_stop;
        var lineEndStopName = lineArr[0].end_stop;
        var lineDistance = parseFloat(lineArr[0].distance).toFixed(2);
        var lineStartTime = lineArr[0].stime;
        var lineEndTime = lineArr[0].etime;

        // Info window content
        var content = [
          "<p>Start stop:", lineStartStopName, "</p>" +
          "<p>End stop:", lineEndStopName, "</p>" +
          "<p>Distance(kms):", lineDistance, "</p>"
        ];


        var infoWindow = new AMap.InfoWindow({
          content: content.join("<br />"),
          autoMove: true
        });

        var _this = this;

        //Add Information window when click the bus line marker
        var clickHandle = AMap.event.addListener(busMarker, 'click', function() {
          //Open the Infowindow with the longitude/latitude
          infoWindow.open(_this.mapObj, busMarkerPosition);
        });

      },

      drawPoi(poiProfile){
        let poiMarkerList = []

        for (let index in poiProfile){
          let poiMarker = new AMap.Marker({
            position: new AMap.LngLat(poiProfile[index]['gravity_lon'], poiProfile[index]['gravity_lat']),
            title: poiProfile[index]['poi_ba_name']
        });
          poiMarkerList.push(poiMarker)
        }

        this.mapObj.add(poiMarkerList); //add marker into the map
        this.mapObj.setFitView();
      },
      drawCircle(hasNanjing,hasWuhan, hasShenzhen,hasChongqing,summaryTableInfo){
        if(hasNanjing == true) {
            this.radius_nanjing = (summaryTableInfo[0].impression/summaryTableInfo[summaryTableInfo.length - 1].impression).toFixed(2)
            this.circle_nanjing = new AMap.CircleMarker ({
            center: new AMap.LngLat(118.774212,32.051145),  // 圆心位置 成都:104.019573,30.53032 南京:118.774212,32.051145 武汉:114.302776,30.577625 深圳:114.058331,22.550603 
            radius: this.radius_nanjing*this.radius_standard >14 ? this.radius_nanjing*this.radius_standard : 14,// 圆半径
            fillColor: 'red',   // 圆形填充颜色
            strokeColor: '#fff', // 描边颜色
            fillOpacity: 0.3,
            strokeWeight: 2, // 描边宽度
          });
        this.mapObj.add(this.circle_nanjing); //add marker into the map
        // 信息窗体的内容
        var info_nanjing = [];
        info_nanjing.push("<h6 class='p7' style='text-align:center'>"+ this.$t('message.Nanjing')+"</h6>");
        info_nanjing.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Number_of_Bus_Lines')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[0].line_qty.toLocaleString()+"</div></div>");  
        info_nanjing.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Viewed_Impression')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[0].impression.toLocaleString()+"</div></div>");
        info_nanjing.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Proposal_Cost')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[0].price.toLocaleString()+"</div></div>");  
        info_nanjing.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Gross_CPM')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[0].cpm.toLocaleString()+"</div></div>");   
        // 创建 infoWindow 实例	
        var infoWindow_nanjing = new AMap.InfoWindow({
          content: info_nanjing.join("")  //传入 dom 对象，或者 html 字符串
        });
        this.circle_nanjing.on('mouseover',()=>{
            infoWindow_nanjing.open(this.mapObj,[118.774212,32.051145]);
        })
        this.circle_nanjing.on('mouseout',()=>{
          infoWindow_nanjing.close(this.mapObj,[118.774212,32.051145]);
        })
        this.circle_nanjing.on('click',()=>{
          document.getElementById('a_nanjing').click()
        })
    
        }
        if (hasWuhan == true) {
          this.radius_wuhan = (summaryTableInfo[1].impression/summaryTableInfo[summaryTableInfo.length - 1].impression).toFixed(2)
            this.circle_wuhan = new AMap.CircleMarker ({
            center: new AMap.LngLat(114.302776,30.577625),  // 圆心位置 成都:104.019573,30.53032 南京:118.774212,32.051145 武汉:114.302776,30.577625 深圳:114.058331,22.550603 
            radius: this.radius_wuhan*this.radius_standard >14 ? this.radius_wuhan*this.radius_standard : 14,// 圆半径
            fillColor: 'red',   // 圆形填充颜色
            strokeColor: '#fff', // 描边颜色
            fillOpacity: 0.3,
            strokeWeight: 2, // 描边宽度
          });

        this.mapObj.add(this.circle_wuhan); //add marker into the map
        
        var info_wuhan = [];
        info_wuhan.push("<h6 class='p7' style='text-align:center'>"+ this.$t('message.Wuhan')+"</h6>");
        info_wuhan.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Number_of_Bus_Lines')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[1].line_qty.toLocaleString()+"</div></div>");  
        info_wuhan.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Viewed_Impression')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[1].impression.toLocaleString()+"</div></div>");
        info_wuhan.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Proposal_Cost')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[1].price.toLocaleString()+"</div></div>"); 
        info_wuhan.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Gross_CPM')+" </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[1].cpm.toLocaleString()+"</div></div>");    
        // 创建 infoWindow 实例	
        var infoWindow_wuhan = new AMap.InfoWindow({
          content: info_wuhan.join("")  //传入 dom 对象，或者 html 字符串
        });
        this.circle_wuhan.on('mouseover',()=>{
            infoWindow_wuhan.open(this.mapObj,[114.302776,30.577625]);
        })
        this.circle_wuhan.on('mouseout',()=>{
          infoWindow_wuhan.close(this.mapObj,[114.302776,30.577625]);
        })
        this.circle_wuhan.on('click',()=>{
          document.getElementById('a_wuhan').click()
        })

        }
        if (hasShenzhen == true) {
          this.radius_shenzhen = (summaryTableInfo[2].impression/summaryTableInfo[summaryTableInfo.length - 1].impression).toFixed(2)
            this.circle_shenzhen = new AMap.CircleMarker ({
            center: new AMap.LngLat(114.058331,22.550603),  // 圆心位置 成都:104.019573,30.53032 南京:118.774212,32.051145 武汉:114.302776,30.577625 深圳:114.058331,22.550603 
            radius: this.radius_shenzhen*this.radius_standard >14 ? this.radius_shenzhen*this.radius_standard : 14,// 圆半径
            fillColor: 'red',   // 圆形填充颜色
            strokeColor: '#fff', // 描边颜色
            fillOpacity: 0.3,
            strokeWeight: 2, // 描边宽度
          });

        this.mapObj.add(this.circle_shenzhen); //add marker into the map

        var info_shenzhen = [];
        info_shenzhen.push("<h6 class='p7' style='text-align:center'>"+ this.$t('message.Shenzhen')+"</h6>");
        info_shenzhen.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Number_of_Bus_Lines')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[2].line_qty.toLocaleString()+"</div></div>");  
        info_shenzhen.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Viewed_Impression')+": </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[2].impression.toLocaleString()+"</div></div>");
        info_shenzhen.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Proposal_Cost')+" :&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[2].price.toLocaleString()+"</div></div>");   
        info_shenzhen.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Gross_CPM')+" </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[2].cpm.toLocaleString()+"</div></div>");   
        
        // 创建 infoWindow 实例	
        var infoWindow_shenzhen = new AMap.InfoWindow({
          content: info_shenzhen.join("")  //传入 dom 对象，或者 html 字符串
        });
        this.circle_shenzhen.on('mouseover',()=>{
            infoWindow_shenzhen.open(this.mapObj,[114.058331,22.550603]);
        })
        this.circle_shenzhen.on('mouseout',()=>{
          infoWindow_shenzhen.close(this.mapObj,[114.058331,22.550603]);
        })
        this.circle_shenzhen.on('click',()=>{
          document.getElementById('a_shenzhen').click()
        })


        }
         if(hasChongqing == true) {
            this.radius_chongqing = (summaryTableInfo[3].impression/summaryTableInfo[summaryTableInfo.length - 1].impression).toFixed(2)
            this.circle_chongqing = new AMap.CircleMarker ({
            center: new AMap.LngLat(106.563324,29.580304),  // 圆心位置 成都:104.019573,30.53032 南京:118.774212,32.051145 武汉:114.302776,30.577625 深圳:114.058331,22.550603 
            radius: this.radius_chongqing*this.radius_standard >14 ? this.radius_chongqing*this.radius_standard : 14,// 圆半径
            fillColor: 'red',   // 圆形填充颜色
            strokeColor: '#fff', // 描边颜色
            fillOpacity: 0.3,
            strokeWeight: 2, // 描边宽度
          });

        this.mapObj.add(this.circle_chongqing); //add marker into the map
        // 信息窗体的内容
        var info_chongqing = [];
        info_chongqing.push("<h6 class='p7' style='text-align:center'>"+ this.$t('message.Chongqing')+"</h6>");
        info_chongqing.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Number_of_Bus_Lines')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[3].line_qty.toLocaleString()+"</div></div>");  
        info_chongqing.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Viewed_Impression')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[3].impression.toLocaleString()+"</div></div>");
        info_chongqing.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Proposal_Cost')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[3].price.toLocaleString()+"</div></div>");  
        info_chongqing.push("<div><div  class='p7' style='display:inline-block'>"+this.$t('message.Gross_CPM')+":&nbsp </div><div class = 'p8'  style='display:inline-block'>"+summaryTableInfo[3].cpm.toLocaleString()+"</div></div>");   
        // 创建 infoWindow 实例	
        var infoWindow_chongqing = new AMap.InfoWindow({
          content: info_chongqing.join("")  //传入 dom 对象，或者 html 字符串
        });
        this.circle_chongqing.on('mouseover',()=>{
            infoWindow_chongqing.open(this.mapObj,[106.563324,29.580304]);
        })
        this.circle_chongqing.on('mouseout',()=>{
          infoWindow_chongqing.close(this.mapObj,[106.563324,29.580304]);
        })
        this.circle_chongqing.on('click',()=>{
          document.getElementById('a_chongqing').click()
        })
    
        }

      // this.mapObj.on('zoomchange',()=>{
        //   this.changeCircleRadius();
      // })
  
      this.mapObj.setStatus({scrollWheel:false});  // 是否开始鼠标滚动缩放


      },
  changeCircleRadius(){
  
      var overlayGroups = new AMap.OverlayGroup(this.circle_nanjing);
      overlayGroups.setOptions({
        radius:(this.radius_nanjing)*((this.radius_standard)*32768/parseInt(Math.pow(2,20 - this.mapObj.getZoom())))}
      )
      var overlayGroups = new AMap.OverlayGroup(this.circle_wuhan);
     
      overlayGroups.setOptions({
        radius:(this.radius_wuhan)*((this.radius_standard)*32768/parseInt(Math.pow(2,20 - this.mapObj.getZoom())))}
      )
      var overlayGroups = new AMap.OverlayGroup(this.circle_shenzhen);
    
      overlayGroups.setOptions({
        radius:(this.radius_shenzhen)*((this.radius_standard)*32768/parseInt(Math.pow(2,20 - this.mapObj.getZoom())))}
      )

      var overlayGroups = new AMap.OverlayGroup(this.circle_chongqing);
    
      overlayGroups.setOptions({
        radius:(this.radius_shenzhen)*((this.radius_standard)*32768/parseInt(Math.pow(2,20 - this.mapObj.getZoom())))}
      )
   
  },
      getRandomColor() {
        var hex = Math.floor(Math.random() * 16777216).toString(16);
        while (hex.length < 6) {
          hex = '0' + hex;
        }
        return '#' + hex;
      },



      getRandomConfortColor() {

        var confortColorList = ["#f44336", "#ffcdd2", "#ef9a9a", "#e57373", "#ef5350", "#f44336", "#e53935", "#d32f2f",
          "#c62828", "#b71c1c", "#ff8a80", "#ff5252", "#e91e63", "#f8bbd0", "#f48fb1", "#f06292", "#ec407a",
          "#e91e63", "#d81b60", "#c2185b", "#ad1457", "#ff80ab", "#ff4081", "#f50057", "#c51162", "#9c27b0",
          "#e1bee7", "#ce93d8", "#ba68c8", "#ab47bc", "#9c27b0", "#8e24aa", "#7b1fa2", "#ea80fc", "#673ab7",
          "#b39ddb", "#9575cd", "#7e57c2", "#673ab7", "#5e35b1", "#512da8", "#b388ff", "#7c4dff", "#3f51b5",
          "#c5cae9", "#9fa8da", "#7986cb", "#5c6bc0", "#3f51b5", "#3949ab", "#303f9f", "#283593", "#8c9eff",
          "#536dfe", "#2196f3", "#bbdefb", "#90caf9", "#64b5f6", "#42a5f5", "#2196f3", "#1e88e5", "#1976d2",
          "#1565c0", "#0d47a1", "#82b1ff", "#448aff", "#03a9f4", "#b3e5fc", "#81d4fa", "#4fc3f7", "#29b6f6",
          "#03a9f4", "#039be5", "#0288d1", "#0277bd", "#01579b", "#80d8ff", "#40c4ff", "#00b0ff", "#0091ea",
          "#00bcd4", "#b2ebf2", "#80deea", "#4dd0e1", "#26c6da", "#00bcd4", "#00acc1", "#0097a7", "#00838f",
          "#006064", "#84ffff", "#18ffff", "#00e5ff", "#00b8d4", "#009688", "#b2dfdb", "#80cbc4", "#4db6ac",
          "#26a69a", "#009688", "#00897b", "#00796b", "#00bfa5", "#4caf50", "#c8e6c9", "#a5d6a7", "#81c784",
          "#66bb6a", "#4caf50", "#43a047", "#388e3c", "#2e7d32", "#69f0ae", "#8bc34a", "#aed581", "#9ccc65",
          "#8bc34a", "#7cb342", "#689f38", "#558b2f", "#cddc39", "#f0f4c3", "#e6ee9c", "#dce775", "#d4e157",
          "#cddc39", "#c0ca33", "#afb42b", "#9e9d24", "#ffeb3b", "#ffee58", "#ffeb3b", "#fdd835", "#fbc02d",
          "#f9a825", "#f57f17", "#ffea00", "#ffd600", "#ffc107", "#ffe082", "#ffd54f", "#ffca28", "#ffc107",
          "#ffb300", "#ffa000", "#ff8f00", "#ffe57f", "#ffd740", "#ffc400", "#ffab00", "#ff9800", "#ffb74d",
          "#ffa726", "#ff9800", "#fb8c00", "#f57c00", "#ef6c00", "#ffd180", "#ffab40", "#ff6d00", "#ff5722",
          "#ffccbc", "#ffab91", "#ff8a65", "#ff7043", "#ff5722", "#f4511e", "#e64a19", "#ff9e80", "#ff6e40",
          "#795548", "#bcaaa4", "#a1887f", "#8d6e63", "#795548", "#6d4c41", "#5d4037", "#757575", "#616161",
          "#607d8b", "#b0bec5", "#90a4ae", "#78909c", "#607d8b", "#546e7a", "#455a64"
        ];
        var index = Math.floor(Math.random() * confortColorList.length);
        return confortColorList[index]
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #input-card {
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border-radius: .25rem;
    border-width: 0;
    border-radius: 0.4rem;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
    bottom: 1rem;
    right: 1rem;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: 0.75rem 1.25rem;
    position: absolute;
    left: 500px;
    top: 400px;
    width: 18rem;
    height: 300px;
    z-index: 200;
  }

  #amap-container {
    position: relative;
    /* width:1210px; */
    width: 100%;
    background-clip: border-box;
    border-radius: .25rem;
    border-width: 0;
    border-radius: 0.4rem;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
    
    @media (max-width:767px) {
      padding-top: 100%
    }
    
    @media (min-width:768px) {
      height: 60rem;
    }
  }

  /deep/ .amap-overlay-text-container {
    @media (max-width:767px) {
      font-size: 12px;
    }
  }
  
  /deep/ .amap-info-content {
    @media (max-width:767px) {
      font-size: 12px;
    }
  }
</style>
